<div>
  <h2 class="mb-6">Cost details</h2>

  <div class="rounded-lg border border-border-secondary p-4 mb-8">
    <div class="flex justify-between items-center mb-3 border-b border-border-secondary pb-3">
      <h4>Total per clean</h4>
      <span class="font-semibold font-mono">{{ estimatedCostPerClean() || '$0.00' }}</span>
    </div>

    <div>
      <div class="flex justify-between items-center mb-2">
        <h4>When your first cleaning task is scheduled, you'll prepay</h4>
        <span class="font-semibold font-mono">{{ totalToPrepay() }}</span>
      </div>
      <div class="text-sm text-text-tertiary leading-relaxed">
        We'll add this to your balance to cover two upcoming cleans. You can withdraw it anytime.
      </div>
    </div>
  </div>

  <div class="mb-8">
    <h2 class="mb-2">How payments work</h2>
    <div class="text-text-tertiary leading-relaxed">
      After each clean, we'll pay the cleaner from your prepaid balance and automatically top it up to stay one clean
      ahead.
    </div>
  </div>

  <div>
    <h4 class="mb-4">Payment method</h4>

    @if (paymentMethodDetailsLoading()) {
      <div class="border border-border-secondary rounded-lg p-4 flex items-center justify-center">
        <ui-loading-spinner class="w-6 h-6" />
      </div>
    } @else if (paymentMethodDetails()) {
      <div class="border border-gray-200 rounded-lg p-4">
        <div class="flex flex-col gap-2">
          <p class="font-medium">{{ paymentMethodDetails().name ?? paymentMethodDetails().derived_name }}</p>
          @if (
            paymentMethodDetails().balance_account?.account_holder?.legal_entity?.transfer_instruments[0]?.metadata
              ?.bankAccount?.bankName
          ) {
            <p class="text-sm text-gray-600">{{
              paymentMethodDetails().balance_account.account_holder.legal_entity.transfer_instruments[0].metadata
                .bankAccount.bankName
            }}</p>
          }
          @if (paymentMethodDetails().adyen?.bank_account_number) {
            <p class="text-sm text-gray-600">•••• {{ paymentMethodDetails().adyen.bank_account_number.slice(-4) }}</p>
          }
        </div>
      </div>
    } @else {
      <div class="border border-border-secondary rounded-lg p-4 text-text-tertiary text-center">
        No payment method available.
        <ui-button variant="link-color" label="Add a payment method" (onClick)="navigateToPayouts()" /> to continue.
      </div>
    }
  </div>
</div>
